export default __webpack_public_path__ + "static/media/boyStudyingDesk.f605ccff.png";